export default "__VITE_ASSET__99802008__"